import {memo} from 'react';

import type {SVGProps} from 'react';

export const InfoIcon = memo(function InfoIcon(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      width={24}
      height={24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <g fill="none">
        <path
          d="M14 23.25C19.1086 23.25 23.25 19.1086 23.25 14C23.25 8.89137 19.1086 4.75 14 4.75C8.89137 4.75 4.75 8.89137 4.75 14C4.75 19.1086 8.89137 23.25 14 23.25Z"
          fill="var(--icon-fill-blue)"
        />
        <path
          d="M15.7 20.5C14.55 21 13.3 21.25 12 21.25C6.9 21.25 2.75 17.1 2.75 12C2.75 9.74998 3.55 7.69998 4.85 6.09998"
          stroke="var(--icon-stroke-blue)"
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M8.1499 3.6C9.2999 3.05 10.6499 2.75 11.9999 2.75C17.0999 2.75 21.2499 6.9 21.2499 12C21.2499 14 20.5999 15.85 19.5499 17.35"
          stroke="var(--icon-stroke-blue)"
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M12 9C12.5523 9 13 8.55228 13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9Z"
          fill="var(--icon-stroke-blue)"
        />
        <path
          d="M12 11.25V16.75"
          stroke="var(--icon-stroke-blue)"
          strokeWidth={1.5}
          strokeMiterlimit={10}
          strokeLinecap="round"
        />
      </g>
    </svg>
  );
});
